// libs
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  schoolTaxonomy: PropTypes.object.isRequired,
};

const defaultProps = {};

const contextTypes = {
  t: PropTypes.func,
};

function Search(props, { t }) {
  const { schoolTaxonomy } = props;
  return (
    <section className="home-search newsletter">
      <h1 className="home-search__title">{t('search.startSearch')}</h1>
      <form action={`${t('routes.search')}`} className="home-search__form">
        <div className="home-search__input field">
          <label>
            <span className="field__label">{t('search.keyword')}</span>
            <input
              name="keywords"
              className="field__input"
              type="text"
              placeholder={t('search.keywordPlaceholder')}
            />
          </label>
        </div>
        <div className="home-search__dropdown field field__select__wrapper">
          <label className="field__label">{t('form.newsletter.schoolLevels')}</label>
          <div className="field__select__box">
            <select name="schoolLevel" className="field__select">
              <option value="all">{t('search.labels.allSchoolLevels')}</option>
              {schoolTaxonomy.categories.map((category) =>
                category.children.length > 0 &&
                <optgroup label={category.name} key={category.name}>
                  {category.children.map((childCategory) =>
                    <option value={childCategory.slug} key={`school-level-filter-${childCategory.slug}`}>{childCategory.name}</option>,
                  )}
                </optgroup>,
              )}
            </select>
          </div>
        </div>
        <button
          className="home-search__button button button--fill"
        >
          {t('search.search')}
        </button>
      </form>
      <div>
        <h2 className="home-search__subtitle">{t('pages.home.search.explore')}</h2>
        <ul className="home-search__contentTypes">
          <li className="home-search__contentType home-search__contentType--activity">
            <NavLink to={`${t('routes.search')}?filterCategory=activity`}>
              {t('pages.activities.title')}
            </NavLink>
          </li>
          <li className="home-search__contentType home-search__contentType--artwork">
            <NavLink to={`${t('routes.search')}?filterCategory=artwork`}>
              {t('pages.artworks.title')}
            </NavLink>
          </li>
          <li className="home-search__contentType home-search__contentType--resource">
            <NavLink to={`${t('routes.search')}?filterCategory=resource`}>
              {t('pages.resources.title')}
            </NavLink>
          </li>
        </ul>
      </div>
    </section>
  );
}

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;
Search.contextTypes = contextTypes;

export default Search;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/search/Search.js